import type { RouteLocationNormalized } from 'vue-router';
import { useOffshoreEligibility } from '../composables/useOffshoreEligibility';
import { useCardAvailability } from '@/shared/smartCard/composables/useCardAvailability';

/**
 * Guard para la página landing "Virtual en dólares" (BMB-3780/BMB-3860).
 *
 * Deja pasar a un país CHL elegible según `useOffshoreEligibility` (país en
 * `OFFSHORE_ELIGIBLE_COUNTRIES` y `feature_offshore_smartcard_chl` encendido)
 * o a un país de Onboarding Global según `isGlobalOnboardingCountry` de
 * `useCardAvailability`. Si no cumple ninguna, redirige a `card`. La ruta ya
 * no lleva `meta.flag`: el kill-switch de Chile sigue vigente porque
 * `isCHLOffshoreEligible` evalúa esa misma flag internamente.
 *
 * Se usa `useOffshoreEligibility` (con `accountStore.getCompanyCountry`) para
 * unificar la fuente de verdad con `useCardAvailability` y evitar depender del
 * orden de carga de wallets en `verifyWalletAndCardTerms`.
 */
export function validateOffshoreLandingEligibility(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized
) {
  if (to.name !== 'cardOffshoreLanding') {
    return true;
  }

  const { isCHLOffshoreEligible } = useOffshoreEligibility();
  const { isGlobalOnboardingCountry } = useCardAvailability();

  if (!isCHLOffshoreEligible.value && !isGlobalOnboardingCountry.value) {
    return { name: 'card' };
  }

  return true;
}
